<template>
  <div class="header">
    <div class="publick">
      <div class="logo fl">
        <router-link to="/">
          <img src="../../assets/logo.png" width="227" height="62" alt="">
        </router-link>
      </div>
      <div class="link fl">
        <li @click="linkClick(index)" :key="index" :class=" index === headindex ? 'chiose':'' "
            v-for="(item,index) in link">
          {{item.name}}
        </li>
      </div>
      <div class="search fl">
        <input type="text" @keyup.enter="search" v-model="searchTxt" placeholder="可在此搜索课程">
        <div @click="search" class="img fl"><img src="../../assets/search.png" width="20" height="20" alt=""></div>
      </div>
      <div @mouseenter="userInfoLive($event)" @mouseleave="userInfoLeave" class="userInfo fr">
        <div style="position: relative;" class="news fl">
          <router-link to="/notice">
            <img src="../../assets/news.png" width="26" height="26" alt="">
            <span v-if=" not_read_message > 0 " style="position: absolute; right: 18px; top: -7px; width: 7px; height: 7px; background-color: red; border-radius: 50%;"></span>
          </router-link>
        </div>
        <div class="portrait fl">
          <router-link to="/userInfo">
            <img :src="avatar" width="30" height="30" alt="">
          </router-link>
        </div>
        <transition name="fade">
          <div v-if="userLayerShow" class="userLayer">
            <div class="LayerCon">
              <div class="avatar">
                <router-link to="/userInfo">
                  <img :src="avatar" width="70" height="70" alt="">
                </router-link>
              </div>
              <div class="name line-clamp-1">{{username}}</div>
              <div class="listUl">
                <router-link tag="li" to="/userInfo/userLive">
                  <img src="./2.png" width="25" class="img2" height="25" alt="">
                  <img src="./1.png" width="25" class="img1" height="25" alt="">
                  直播预约
                </router-link>
                <router-link tag="li" to="/userInfo/userCourse">
                  <img src="./4.png" width="25" class="img2" height="25" alt="">
                  <img src="./3.png" width="25" class="img1" height="25" alt="">
                  线上课程
                </router-link>
                <router-link tag="li" to="/userInfo/userIntegral">
                  <img src="./6.png" width="25" class="img2" height="25" alt="">
                  <img src="./5.png" width="25" class="img1" height="25" alt="">
                  我的积分
                </router-link>
                <router-link tag="li" to="/userInfo/userSetup">
                  <img src="./8.png" width="25" class="img2" height="25" alt="">
                  <img src="./7.png" width="25" class="img1" height="25" alt="">
                  安全设置
                </router-link>
              </div>
              <div @click="LogOut" class="LogOut">退出登录</div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        searchTxt: '',
        link: [
          {
            path: '/',
            name: '首页'
          },
          {
            path: '/CourseList',
            name: '公开课'
          },
          {
            path: '/learning',
            name: '学习中心'
          },
          {
            path: '/live',
            name: '直播'
          },
          {
            path: '/newsList',
            name: '新闻资讯'
          }
        ],
        userLayerShow: false,
        username: '',
        not_read_message: ''
      }
    },
    created () {
      this.avatar = JSON.parse(localStorage.getItem('login')).avatar
      this.username = JSON.parse(localStorage.getItem('login')).username
      this.not_read_message = this.$store.state.not_read_message
      console.log(this.$store.state.HeadFooter)
    },
    methods: {
      userInfoLive (e) {
        this.userLayerShow = true
      },
      userInfoLeave () {
        this.userLayerShow = false
      },
      LogOut () { // 退出登录
        localStorage.removeItem('login')
        this.$router.replace('/login')
      },
      linkClick (index) {
        this.$store.state.headindex = index
        this.$router.push({
          path: this.link[index].path
        })
      },
      search () {
        if (this.searchTxt === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入搜索关键词'
          })
          return false
        }
        this.$router.push({
          path: '/searchVue',
          query: {
            keyword: this.searchTxt
          }
        })
      }
    },
    computed: {
      headindex: function () {
        return this.$store.state.headindex
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .header {
    width: 100%;
    height: 100px;
    box-shadow: 0px 0px 10px #ebeef1;

    .publick {
      position: relative;

      .logo {
        width: 227px;
        height: 62px;
        margin: 19px 0 0 0;
      }

      .link {
        width: 400px;
        height: 100px;
        line-height: 100px;
        margin-left: 50px;

        .chiose {
          color: #ff8484;
        }

        li {
          margin: 0 13px;
          text-align: center;
          float: left;
          cursor: pointer;
          font-size: 18px;
        }
      }

      .search {
        width: 250px;
        height: 60px;
        margin: 20px 0 0 50px;
        border-bottom: 1px solid #cacaca;

        input {
          width: 200px;
          height: 60px;
          border: 0;
          color: #a1a1a1;
          font-size: 16px;
          text-indent: 10px;
          float: left;
        }

        .img {
          width: 50px;
          height: 60px;
          cursor: pointer;

          img {
            display: block;
            margin: 20px 0 0 15px;
          }
        }
      }

      .userInfo {
        height: 40px;
        width: 160px;
        margin: 30px 0 0 0;

        .userLayer {
          padding: 40px;

          .LayerCon {
            width: 390px;
            height: 390px;
            background-color: #fff;
            border-radius: 20px;
            box-shadow: 0px 0px 10px #ebeef1;
            position: relative;
            right: 270px;
            top: 50px;
            z-index: 99;
            overflow: hidden;

            .avatar {
              width: 70px;
              height: 70px;
              margin: 30px auto;

              img {
                border-radius: 50%;
              }
            }

            .name {
              font-size: 20px;
              color: #484848;
              margin: 0 auto;
              text-align: center;
            }

            .listUl {
              width: 335px;
              margin: 30px auto;
              overflow: hidden;

              li {
                width: 90px;
                height: 45px;
                padding-left: 70px;
                line-height: 45px;
                background-color: #f8fafc;
                border-radius: 5px;
                color: #1c1f21;
                position: relative;
                cursor: pointer;
                margin: 15px 0 0 0;

                .img1 {
                  display: none;
                }

                img {
                  position: absolute;
                  left: 30px;
                  top: 10px;
                }

                &:hover {
                  background-color: #fff2f2;
                  color: #ff8484;

                  .img1 {
                    display: block;
                  }

                  .img2 {
                    display: none;
                  }
                }

                &:nth-child(2n-1) {
                  float: left;
                }

                &:nth-child(2n) {
                  float: right;
                }
              }
            }

            .LogOut {
              width: 135px;
              height: 30px;
              text-align: center;
              line-height: 30px;
              margin: 0 auto;
              border: 1px solid #ff8484;
              color: #ff8484;
              cursor: pointer;
              border-radius: 5px;
            }
          }

        }

        .news {
          width: 79px;
          height: 26px;
          border-right: 1px solid #adadad;
          margin-top: 7px;
          cursor: pointer;

          img {
            display: block;
            margin: 2px auto 0;
          }
        }

        .portrait {
          width: 80px;
          height: 40px;
          cursor: pointer;

          img {
            display: block;
            margin: 5px auto 0;
            border-radius: 50%;
          }
        }
      }

      .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
      }

      .fade-enter, .fade-leave-to {
        opacity: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue